import {BGProcess} from 'common/src/modules/backgroundProcess/backgroundProcess.types';
import CLLocalStorage from 'common/src/modules/localStorage/CLLocalStorage';
import Subject from 'common/src/utils/pubsub/subject';
import {CLRef} from '../shared.types';
import {LS_KEY__BG_PROCESSES} from '../../localStorage/CLLocalStorage.consts';

const savedProcesses: BGProcess[] = JSON.parse(CLLocalStorage.get(LS_KEY__BG_PROCESSES) || '[]');
const processes = new Subject<BGProcess[]>(savedProcesses);
const pollingIntervalRef: CLRef<NodeJS.Timeout> = {current: null};

export {savedProcesses, processes, pollingIntervalRef};
